import { render, staticRenderFns } from "./PlayersPendingAdd.vue?vue&type=template&id=3c764179&"
import script from "./PlayersPendingAdd.vue?vue&type=script&lang=js&"
export * from "./PlayersPendingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports